import { render, staticRenderFns } from "./SubheadingsAndDividers.vue?vue&type=template&id=adc63ad2&"
import script from "./SubheadingsAndDividers.vue?vue&type=script&lang=js&"
export * from "./SubheadingsAndDividers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports